<div class="wrapper" [class.custom-scroll]="isDrsite">
  <!--<h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>-->
  <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
  <div class="container px-0">
    <form [formGroup]="appointmentForm" *ngIf="!ShowSlotsScreens">
      <div class="">
        <p class="mb-2 fw-bold form-label">
          {{'Appointment.appointmentType.label' | translate}}<span class="text-danger">*</span>
        </p>
        <ul class="list-inline list-unstyled mb-0 new-symptoms-list" [ngClass]="{'rtl': isRtl}">

          <li class="list-inline-item" *ngIf="Practice_code !== '1013886'">
            <div class="custom-control custom-radio">
              <input [ngClass]="isDrsite ? 'custom-control-blue' : 'custom-control-input'" type="radio" id="office"
                formControlName="appointmenttype" value="office" (change)="selectAppointmenttype('office')">
              <label style="margin-bottom:0px !important;" class=" cursor-pointer" for="office"
                [ngClass]="isDrsite ? '' : 'custom-control-label'">
                {{'Appointment.appointmentType.options.office' | translate}}
              </label>
            </div>
          </li>
          <li class="list-inline-item rd" [style.margin-left]="Practice_code === '1013886' ? '0' : '60px'">
            <div class="custom-control custom-radio">
              <input [ngClass]="isDrsite ? 'custom-control-blue' : 'custom-control-input'" type="radio" id="telehealth"
                formControlName="appointmenttype" value="telehealth" (change)="selectAppointmenttype('telehealth')">
              <label style="margin-bottom:0px !important;" class="cursor-pointer"
                [ngClass]="isDrsite ? '' : 'custom-control-label'" for="telehealth">
                {{'Appointment.appointmentType.options.telehealth' | translate}}
              </label>

            </div>
          </li>
        </ul>
        <div class="mb-2 err" *ngIf="getappointmentForm.appointmenttype.invalid && getappointmentForm.appointmenttype.touched
&& getappointmentForm.appointmenttype.errors!.required">
          {{'Appointment.appointmentType.requiredError' | translate}}
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-4 mt-3">
          <div class="form-group border-bottom mb-2">
            <label class="form-label fw-bold">
              {{'Appointment.provider.label' | translate}}<span class="text-danger">*</span>
            </label>
            <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="provider"
                [ngStyle]="{'border' : getappointmentForm.provider.invalid && getappointmentForm.provider.touched && getappointmentForm.provider.errors!.required ? '1px solid red' : ''}"
                (change)="onChangeDate()">
                <option value="" disabled selected>{{'Appointment.provider.select_Provider' | translate}}</option>
                <option *ngFor="let provider of providerData" [value]="provider.providerCode">
                  {{provider.providerName}}
                </option>
              </select>
            </div>
          </div>

          <div class="mb-2">
            <span *ngIf="getappointmentForm.provider.invalid && getappointmentForm.provider.touched
            && getappointmentForm.provider.errors!.required" class="err">
              {{'Appointment.provider.requiredError' | translate}}
            </span>
          </div>
        </div>
        <div class="col-md-4 mt-3">
          <div class="form-group border-bottom mb-2">
            <label class="form-label fw-bold">
              {{'RegistrationPage.location.label' | translate}}<span class="text-danger">*</span>
            </label>
            <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="location"
                [ngStyle]="{'border' : getappointmentForm.location.invalid && getappointmentForm.location.touched && getappointmentForm.location.errors!.required ? '1px solid red' : ''}"
                (change)="onChangeDate()">
                <option value="" disabled selected>{{'RegistrationPage.location.placeholder' | translate}}</option>
                <option *ngFor="let location of providerLocation" [value]="location.locationCode">
                  {{Practice_code === '1013886' ? 'Westminster' : location.locationName }}
                </option>
              </select>
              <!--<label [ngClass]="getappointmentForm.location.invalid && getappointmentForm.location.touched
                && getappointmentForm.location.errors!.required ? 'text-danger' : ''">{{'RegistrationPage.location.label' | translate}}<span class="text-danger">*</span></label>-->
            </div>

          </div>
          <div class="mb-2">
            <span *ngIf="getappointmentForm.location.invalid && getappointmentForm.location.touched
                           && getappointmentForm.location.errors!.required" class="err">
              {{'RegistrationPage.location.error' | translate}}
            </span>
          </div>
        </div>
        <div class="col-md-4 mt-3">
          <div class="form-group border-bottom mb-2">
            <!-- <label class="d-md-block d-none mb-1">&nbsp;</label> -->
            <label class="form-label fw-bold">
              {{'Appointment.reason.label' | translate}}<span class="text-danger">*</span>
            </label>
            <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="reason"
                [ngStyle]="{'border' : getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required ? '1px solid red' : ''}"
                (change)="onchangeReason()">
                <option value="" disabled selected>{{'Appointment.reason.selectVisitReason' | translate}}</option>
                <ng-container *ngIf="appointmentReasonData">
                  <option *ngFor="let reason of appointmentReasonData" [value]="reason.reasonId">
                    {{reason.reasonName}}
                  </option>
                </ng-container>

              </select>
              <!--<label [ngClass]="getappointmentForm.reason.invalid && getappointmentForm.reason.touched
                && getappointmentForm.reason.errors!.required ? 'text-danger' : ''">{{'Appointment.reason.label' | translate}} <span class="text-danger">*</span> </label>-->
            </div>

          </div>
          <div class="mb-2">
            <span
              *ngIf="getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required"
              class="err">
              {{'Appointment.reason.requiredError' | translate}}
            </span>
          </div>
        </div>
        <!-- <div class="col-auto mt-3">
            <div class="form-group criteria-nav">
              <label>Criteria</label>
              <ul class="sub-tabs nav nav-pills mb-3 mt-3" id="pills-tab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab"
                     aria-controls="pills-home" aria-selected="true" (click)="searchAvailable(true)">{{'Appointment.appointmentSlots.first_available' | translate }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab"
                    aria-controls="pills-profile" aria-selected="false" (click)="searchAvailable(false)">Date</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-auto" [ngStyle]="{'display':isFirstAvailibleButton ? 'none' : ''}">
            <div class="form-group">
              <label>Select Date</label>
              <input class="form-control" formControlName="selectedDateApp" type="date" [min]="minDateFull"
                (change)="getAppointmentTimeSlot()" />
            </div>
          </div> -->

        <div class="col-12 col-sm-auto mb-3 mb-sm-0 pl-0 pl-sm-2 mt-3">
          <label class="d-sm-block d-none">&nbsp;</label>
          <button class="btn rounded btn-block" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
            (click)="getAppointmentTimeSlot()">
            {{
            'button.search' |
            translate
            }}
          </button>
        </div>
      </div>
    </form>
    <ng-container *ngIf="ShowSlotsScreens && appointmentSlotsLoaded">
      <form [formGroup]="appointmentForm"
            class="align-items-center d-flex flex-column justify-content-center mb-2  row ">
        <div class="col-md-4 p-0">
          <div class="form-group border-bottom mb-2">
            <!-- <label class="form-label fw-bold">
          {{'RegistrationPage.location.label' | translate}}<span class="text-danger">*</span>
        </label> -->
            <div class=" IconsDropdown1" [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="location"
                      [ngStyle]="{'border' : getappointmentForm.location.invalid && getappointmentForm.location.touched && getappointmentForm.location.errors!.required ? '1px solid red' : ''}"
                      (change)="onChangeDate()">
                <option value="" disabled selected>{{'RegistrationPage.location.placeholder' | translate}}</option>
                <option *ngFor="let location of providerLocation" [value]="location.locationCode">
                  {{Practice_code === '1013886' ? 'Westminster' : location.locationName }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2">
            <span *ngIf="getappointmentForm.location.invalid && getappointmentForm.location.touched
                         && getappointmentForm.location.errors!.required" class="err">
              {{'RegistrationPage.location.error' | translate}}
            </span>
          </div>
        </div>
        <div class="col-md-4 mt-2 p-0">
          <div class="form-group border-bottom mb-2">
            <!-- <label class="form-label fw-bold">
          {{'Appointment.provider.label' | translate}}<span class="text-danger">*</span>
        </label> -->
            <div class=" IconsDropdown2" [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="provider"
                      [ngStyle]="{'border' : getappointmentForm.provider.invalid && getappointmentForm.provider.touched && getappointmentForm.provider.errors!.required ? '1px solid red' : ''}"
                      (change)="onChangeDate()">
                <option value="" disabled selected>{{'Appointment.provider.select_Provider' | translate}}</option>
                <option *ngFor="let provider of providerData" [value]="provider.providerCode">
                  {{provider.providerName}}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-2">
            <span *ngIf="getappointmentForm.provider.invalid && getappointmentForm.provider.touched
            && getappointmentForm.provider.errors!.required" class="err">
              {{'Appointment.provider.requiredError' | translate}}
            </span>
          </div>
        </div>
        <div class="col-md-4 mt-2 p-0">
          <div class="form-group border-bottom mb-2">
            <div [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
              <select translate="no" class="form-control border-0" formControlName="reason"
                      [ngStyle]="{'border' : getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required ? '1px solid red' : ''}"
                      (change)="onchangeReason()">
                <option value="" disabled selected>{{'Appointment.reason.selectVisitReason' | translate}}</option>
                <ng-container *ngIf="appointmentReasonData">
                  <option *ngFor="let reason of appointmentReasonData" [value]="reason.reasonId">
                    {{reason.reasonName}}
                  </option>
                </ng-container>

              </select>
             
            </div>

          </div>
          <div class="mb-2">
            <span *ngIf="getappointmentForm.reason.invalid && getappointmentForm.reason.touched && getappointmentForm.reason.errors!.required"
                  class="err">
              {{'Appointment.reason.requiredError' | translate}}
            </span>
          </div>
        </div>
      </form>
      <ng-container *ngIf="!appointmentSlotsLoaded && !appointmentTimeSlotFlag">
        <!-- Show loader here -->
        <div class="text-center mt-4">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Loading available slots...</p>
        </div>
      </ng-container>
      <div class="align-items-center row p-2 rounded custom-height"
        [ngClass]="isDrsite ? 'bg-c-blue-1' : 'bg-c-grey-l'">

        <div class="m-auto rounded text-center text-md-left checkIn-calendar col-md-6">
          <mat-form-field appearance="outline" class="w-auto">
            <h5 class="mb-0 fs-20 fw-bold text-center" (click)="openMonthPicker(monthPicker)">
              {{ selectedMonthName }} &#160;
            </h5>
            <input matInput [matDatepicker]="monthPicker" hidden>
            <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
            <mat-datepicker #monthPicker startView="year" panelClass="month-picker"
              (monthSelected)="chosenMonthHandler($event, monthPicker)">
            </mat-datepicker>
          </mat-form-field>

        </div>

        <div class="col-md-6 col-xl-6">
          <div class="carousel slide " [ngClass]="{'date-timecarousel-blue': isDrsite,'date-time-carousel': !isDrsite,}"
            data-interval="false" data-ride="carousel" id="carouselAppointment">
            <div class="carousel-inner text-center">
              <div class="carousel-item active">
                <div class="mx-lg-5 mx-md-2">
                  <div class="row no-wrap week-calendar">
                    <div class="custom-width" *ngFor="let reqApp of dSeriesFinal" (click)="onAppointmentDate(reqApp);"
                      [class.selected-time]="reqApp.isSelected" style="cursor: pointer;">
                      <div class="custom-date-time-picker-container bg-white ng-star-inserted px-2 py-1 rounded-lg">
                        <p class="custom-font mb-1">{{reqApp.day}}</p>
                        <h5 class="custom-font">{{reqApp.date}}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev carousel-control-custom-prev" data-slide="prev" role="button"
              (click)="previousAppointmentDate()">
              <span aria-hidden="true" class="carousel-control-prev-icon"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next carousel-control-custom-next" data-slide="next" role="button"
              (click)="nextAppointmentDate()">
              <span aria-hidden="true" class="carousel-control-next-icon"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto">
              <button class="btn"
                [ngClass]="{'selected-slot-btn': !isDrsite && showOnlyMorningSlots,'morningBtn-blue': isDrsite,'morningBtn': !isDrsite,'selected-slot-btn-blue':isDrsite && showOnlyMorningSlots}"
                (click)="toggleMorningSlots()">
                <i class="fas fa-sun"></i> {{'Appointment.appointmentSlots.morning_Slots' | translate}}
              </button>
            </div>
            <div class="col-auto">
              <button class="btn "
                [ngClass]="{'selected-slot-btn': !isDrsite && showOnlyEveningSlots,'eveningBtn-blue': isDrsite,'eveningBtn': !isDrsite,'selected-slot-btn-blue':isDrsite && showOnlyEveningSlots}"
                (click)="toggleEveningSlots()">
                <i class="fas fa-moon"></i> {{'Appointment.appointmentSlots.evening_Slots' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="mt-3 d-flex justify-content-end align-items-center">
          <div class="form-check ml-2">
            <input class="m-2" type="checkbox" id="firstAvailable" [(ngModel)]="isFirstAvailable"
              (change)="searchAvailable(isFirstAvailable)">
            <label style="font-size:17px" class="form-check-label" for="firstAvailable">
              {{'Appointment.appointmentSlots.first_available' | translate}}
            </label>
          </div>
        </div>-->

      <div class="schedule-appt-scroll position-relative">
        <div class="avialble-option" *ngIf="appointmentTimeSlotFlag == true">
          <div class="form-check ml-2">
            <input class="m-2" type="checkbox" id="firstAvailable" [(ngModel)]="isFirstAvailable"
              (change)="searchAvailable(isFirstAvailable)">
            <label style="font-size:17px" class="form-check-label" for="firstAvailable">
              {{'Appointment.appointmentSlots.first_available' | translate}}
            </label>
          </div>
        </div>
        <ng-container *ngIf="appointmentTimeSlotFlag == true else notFoundData">
          <div class="flex-wrap border-bottom mt-3 mt-xl-4 ltr-component"
            *ngFor="let group of groupedSlotsArray; let j = index; trackBy: trackByFn">
            <div>
              <h5 class="fw-bold">{{ formatSlotDate(group.date) }}</h5>
              <!--<div>
                  <h5 class="mb-2 provider-detail">
                    <i class="fa fa-user-md fs-16 text-dark-blue mr-1"></i>
                    {{ selectedProvider.providerName}}
                  </h5>
                </div>-->
            </div>

            <div class="align-items-start d-flex flex-wrap border-bottom mt-1 mt-xl-4 p-2 rounded row"
              [ngClass]="isDrsite ? 'bg-c-blue-1' : 'bg-c-grey-l'">

              <div class="col-md-5 pl-0 col-xl-5 mt-xl-0 ltr-component d-flex align-items-center">
                <div class="d-flex pb-1 mb-2">
                  <!--<div class="app_detail ml-2">
                      <h5 class="mb-2 provider-detail">
                        <i class="fa fa-map-marker fs-16 text-dark-blue mr-1"></i>
                        {{ selectedLocation.locationName }}
                      </h5>
                      <h5 class="mb-2 provider-detail">
                        <i class="fa fa-heartbeat fs-16 text-dark-blue mr-1"></i>
                        {{ selectedReason.reasonName }}
                      </h5>
                    </div>-->
                </div>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-12 col-xl-7 text-right">
                <!-- <div class="row d-flex justify-content-center" style="padding-bottom:15px"> -->
                <div class="justify-content-md-end m-auto row text-right w-100" style="padding-bottom:15px" [ngClass]="{
       'd-flex justify-content-center flex-wrap': isFirstAvailable
     }">

                  <ng-container *ngIf="group.slots.length > 0; else notFound">

                    <div *ngIf="isFirstAvailable; else other_content">
                      <div *ngFor="let sl of group.slots">
                        <button type="button" class="btn  mt-2 rounded bg-white" [ngClass]="{
'active': isSlotSelected(sl),
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onSelectSlot($event, sl)">
                          <span>{{sl.availableDate}}&nbsp;{{sl.availableSlot}} </span>
                        </button>
                      </div>
                    </div>
                    <ng-template #other_content>

                      <ng-container *ngIf="getFilteredSlots(group) as filteredSlots">
                        <div *ngFor="let sl of filteredSlots; let i = index">
                          <ng-container *ngIf="i < 6 || expandedSlots[j]">
                            <div class="btn  mt-2 rounded time-slot-btn bg-white" [ngClass]="{
'active': isSlotSelected(sl),
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onSelectSlot($event, sl)">
                              <span>{{ sl.availableSlot }}</span>
                            </div>
                            &nbsp;
                          </ng-container>
                        </div>

                        <!-- "More" Button -->
                        <button type="button" class="btn mt-2 rounded time-slot-btn mr-2 bg-white" [ngClass]="{
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onClickMore(j)" *ngIf="filteredSlots.length > 6 && !expandedSlots[j]">
                          More
                        </button>

                        <!-- "Less" Button -->
                        <button type="button" class="btn  mt-2 rounded time-slot-btn mr-2 bg-white" [ngClass]="{
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onClickMore(j)" *ngIf="filteredSlots.length > 6 && expandedSlots[j]">
                          Less
                        </button>
                        <div class=" w-100 mt-3 text-center ltr-component" [ngClass]="{
'waitlist-inline-blue': isDrsite,
'waitlist-inline': !isDrsite,}">
                          <label>{{'Appointment.waitList.cant_find_a_time' | translate}}</label>
                          <a href="javascript:void(0)" (click)="onWaitListClick(group.date)">
                            {{'Appointment.waitList.add_to_waitlist' | translate}}
                          </a>
                        </div>
                      </ng-container>

                    </ng-template>


                  </ng-container>

                  <ng-template #notFound>
                    <div class="col-sm-12 text-center">
                      <label style="color: #de2125; font-weight: bold;">No slot is available.</label>
                    </div>
                  </ng-template>

                </div>
              </div>

            </div> <!-- End of Card -->
          </div>
        </ng-container>
      </div>
      <ng-template #notFoundData>
        <div class="d-flex justify-content-center" style="padding-top: 15px;">
          <label style="color: #de2125; font-weight: bold;">{{'Appointment.appointmentSlots.no_slots_available' |
            translate}}</label>
        </div>
      </ng-template>

    </ng-container>

    <ngx-spinner [fullScreen]="true" name="timeslots" bdColor="rgba(232,238,243,0.61)"  size="large"  color="#103b72"
       type="ball-spin"></ngx-spinner>

  </div>
  <div class="modal fade in modal-alert bd-example-modal-sm" id="noLabWorkModal" tabindex="-1" role="dialog"
    data-backdrop="static" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4 text-center">
          <h5 class="font-weight-bolder mb-3 text-danger"><strong> {{'Alerts.lab_work'|translate}}</strong></h5>
          <p class="mb-3">{{'Alerts.lab_work_popup_body'|translate}}</p>
          <div class="text-center">
            <button type="button" data-toggle="modal" data-dismiss="modal"
              [ngClass]="isDrsite ? 'btn blue-btn' : 'btn btn-primary'">
              {{'button.ok'|translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade in modal-alert bd-example-modal-sm" id="waitlistModal" tabindex="1" role="dialog"
    data-backdrop="static" data-keyboard="false" [class.custom-scroll]="isDrsite">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div [ngClass]="isDrsite ? 'modal-header-blue' : 'modal-header'">
          <h5 class="modal-title"> <span>{{'Appointment.waitList.join_the_wait_list' | translate}}</span></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-3 " style="max-height: 350px; overflow-y: auto;">
          <p class="text-center">{{'Appointment.waitList.choose_your_availibility_below' | translate}}</p>

          <div class="text-center">
            <div class="flex-wrap border-bottom mt-3 mt-xl-4 ltr-component"
              *ngFor="let group of waitlistSlotsArray; let j = index; trackBy: trackByFn">
              <div class="col-12 d-flex justify-content-center flex-wrap">
                <div class="justify-content-md-end m-auto row text-right w-100" style="padding-bottom:15px"
                  [ngClass]="{'d-flex justify-content-center flex-wrap': isFirstAvailable}">

                  <ng-container *ngIf="group.slots.length > 0">

                    <div *ngFor="let sl of group.slots; let i = index;">
                      <ng-container *ngIf="i < 6 || expandedSlots[j]">
                        <!-- <button type="button"  -->
                        <div class="btn  mt-2 rounded time-slot-btn bg-white" [ngClass]="{
                             'active': isSlotSelected(sl),
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onSelectSlot($event, sl)">
                          <span>{{ sl.availableSlot }}</span>
                        </div>
                        <!-- </button> -->
                        &nbsp;
                      </ng-container>
                    </div>

                    <!-- "More" Button -->
                    <button type="button" class="btn mt-2 rounded time-slot-btn mr-2 bg-white" [ngClass]="{
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onClickMore(j)" *ngIf="group.slots.length > 6 && !expandedSlots[j]">
                      More
                    </button>
                    <div class="slot-container">
                      <!-- "Less" Button -->
                      <button type="button" class="btn mt-2 rounded time-slot-btn mr-2 bg-white" [ngClass]="{
'btn-outline-info-blue': isDrsite,
'btn-outline-info': !isDrsite,}" (click)="onClickMore(j)" *ngIf="group.slots.length > 6 && expandedSlots[j]">
                        Less
                      </button>
                    </div>

                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" type="button" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
            (click)="ShowSlotsScreens ? SelectPatientOption('walkin') : getAppointmentTimeSlot()">
            {{'button.next'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <button class="btn" type="button" [ngClass]="isDrsite ? 'blue-btn-outline' : 'btn-outline-primary'"
        (click)="backPage()">{{'button.back'|translate}}</button>
      <button class="btn " type="button" [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'"
        (click)="ShowSlotsScreens ? SelectPatientOption('walkin') : getAppointmentTimeSlot()">
        {{'button.next'|translate}}
      </button>

    </div>
  </div>
</footer>
